import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as requirement from '../requirement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: requirement.RESOURCE.payload.dimension.partialId,
      partialId: requirement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Path of the technical requirement file that explains how to implement this Jira task, e.g. requirements/TS-101.md.',
    isOptional: true,
    name: 'Technical Requirement File',
    partialId: PartialId.Standard.create('tech_req_file'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
